// GAVION X3: Paramètres → Qualité des données (admins).
export const dataQualityFr = {
  title: "Qualité des données",
  // GAVION import duplicates / suspect emails: the menu count (duplicate pairs + suspect emails)
  badge:
    "%{smart_count} élément à examiner |||| %{smart_count} éléments à examiner",
  intro:
    "Fusionnez les compagnies en double et complétez les fiches incomplètes avant qu'elles n'arrivent dans la file d'appels.",
  demo_notice:
    "Mode démo : la détection et la fusion sont calculées localement sur les données de démonstration.",
  load_error: "Impossible de charger les données. Réessayez.",
  tabs: {
    duplicates: "Doublons",
    fix: "À corriger",
    suspect_emails: "Courriels douteux", // GAVION suspect emails (89_)
  },
  reasons: {
    phone: "Même téléphone",
    name_city: "Même nom et ville",
    website: "Même site web",
  },
  duplicates: {
    empty: "Aucun doublon à examiner. Tout est propre !",
    count:
      "%{smart_count} paire à examiner |||| %{smart_count} paires à examiner",
    more: "Seules les %{shown} premières paires sont affichées.",
    compare: "Comparer",
    close: "Fermer",
    survivor: "Fiche conservée",
    survivor_hint:
      "L'autre fiche sera supprimée ; ses appels, notes, contacts, affaires, tâches et courriels seront rattachés à la fiche conservée.",
    keep: "Conserver « %{name} » (#%{id})",
    field: "Champ",
    record: "Fiche #%{id}",
    pick: "Garder la valeur de la fiche #%{id} pour « %{field} »",
    related: "Historique",
    related_value:
      "%{calls} appels · %{notes} notes · %{contacts} contacts · %{deals} affaires · %{tasks} tâches · %{emails} courriels",
    counters_hint:
      "Le nombre de tentatives le plus élevé, la date d'ajout la plus ancienne et le dernier appel le plus récent sont conservés, les étiquettes sont réunies. « Ne pas appeler » et les désabonnements ne sont jamais perdus ; les valeurs non conservées sont recopiées dans une note.",
    email_suppressed: "désabonné",
    phone_suppressed: "ne pas appeler",
    merge: "Fusionner",
    not_duplicate: "Pas un doublon",
    confirm_title: "Fusionner ces deux compagnies ?",
    confirm_body:
      "La fiche « %{loser} » (#%{loser_id}) sera supprimée et tout son historique sera rattaché à « %{survivor} » (#%{survivor_id}). Cette action est irréversible.",
    confirm: "Fusionner",
    cancel: "Annuler",
    merged: "Compagnies fusionnées.",
    dismissed: "Paire écartée : elle ne sera plus proposée.",
  },
  // GAVION suspect emails (89_): « Courriels douteux »
  suspect_emails: {
    title: "Courriels douteux (%{count})",
    intro:
      "Courriels de compagnies qui ressemblent à une faute de frappe ou qui ont déjà rebondi. Vérifiez-les avant le prochain envoi.",
    empty: "Aucun courriel douteux. Tout est propre !",
    more: "Seules les %{shown} premières compagnies sont affichées.",
    current: "Courriel actuel : %{email}",
    reason_typo: "Faute probable : ressemble à %{domain} (%{source})",
    sources: {
      contact: "contact",
      website: "site web",
    },
    reason_bounced: "Un courriel envoyé à cette adresse est revenu",
    replace: "Remplacer par %{email}",
    other: "Saisir une autre adresse",
    other_label: "Nouvelle adresse pour %{name}",
    placeholder: "nom@compagnie.ca",
    invalid: "Adresse invalide.",
    save: "Remplacer",
    dismiss: "Ignorer",
    confirm_title: "Remplacer le courriel ?",
    confirm_body:
      "Le courriel de « %{name} » passera de %{from} à %{to}. Les prochains envois iront à la nouvelle adresse.",
    confirm: "Remplacer",
    cancel: "Annuler",
    saved: "Courriel remplacé.",
    dismissed: "Courriel gardé : il ne sera plus signalé, sauf s'il change.",
    dismissed_suppressed:
      "Courriel gardé : il ne sera plus signalé ici, mais les envois restent bloqués tant qu'il n'est pas changé.",
  },
  fields: {
    name: "Nom",
    phone_number: "Téléphone",
    email: "Courriel",
    website: "Site web",
    address: "Adresse",
    zipcode: "Code postal",
    city: "Ville",
    state_abbr: "Province",
    region: "Région",
    country: "Pays",
    trade: "Métier",
    segment: "Segment",
    sector: "Secteur",
    description: "Description",
    linkedin_url: "LinkedIn",
    estimated_employees: "Employés (estimé)",
    language: "Langue",
    assigned_sales_id: "Représentant",
    prospect_status: "Statut",
  },
  fix: {
    kinds: {
      missing_phone: "Sans téléphone",
      invalid_phone: "Numéro invalide",
      missing_trade: "Sans métier",
      missing_region: "Sans région",
    },
    kind_label: "Type de correction",
    empty: "Rien à corriger ici.",
    open: "Ouvrir la fiche",
    current: "Actuel : %{phone}",
    no_phone: "Aucun numéro",
    new_phone: "Nouveau numéro pour %{name}",
    placeholder: "514 555-0123",
    valid: "Numéro valide : %{phone}",
    invalid: "Numéro invalide : 10 chiffres nord-américains attendus.",
    save: "Enregistrer",
    bad_number: "Marquer mauvais numéro",
    skip: "Passer",
    saved: "Numéro enregistré.",
    saved_do_not_call:
      "Numéro enregistré. Il figure sur la liste « Ne pas appeler » : la compagnie passe en « Ne pas appeler ».",
    marked: "Compagnie marquée « mauvais numéro ».",
    previous: "Précédent",
    next: "Suivant",
    page: "%{from}–%{to} sur %{total}",
  },
  errors: {
    forbidden: "Action réservée aux administrateurs.",
    lead_locked:
      "Un représentant appelle cette compagnie en ce moment. Réessayez dans quelques minutes.",
    not_found: "Cette compagnie n'existe plus. La liste a été actualisée.",
    invalid_pair: "Choisissez deux compagnies différentes.",
    invalid_field: "Choix de champ invalide.",
    invalid_phone: "Numéro invalide : 10 chiffres nord-américains attendus.",
    phone_taken: "Ce numéro appartient déjà à une autre compagnie (#%{id}).",
    unhandled_reference:
      "Fusion impossible : des données liées à cette compagnie (%{table}) ne peuvent pas être déplacées. Contactez un administrateur.",
    unhandled_reference_subscription:
      "Fusion impossible : la compagnie fusionnée a un abonnement ou des commissions (l'historique versé est gardé). Gardez plutôt celle-là, ou contactez un administrateur.",
    // GAVION import duplicates (88_)
    both_active_subscriptions:
      "Les deux compagnies ont un abonnement actif : annulez-en un avant de fusionner.",
    paid_commission_lines:
      "La compagnie fusionnée a des commissions déjà versées : gardez plutôt celle-là.",
    invalid_email: "Adresse courriel invalide.", // GAVION suspect emails (89_)
    unknown: "Une erreur est survenue. Réessayez.",
  },
};
